import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Keine Ergebnisse gefunden", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Passe deine Filter an, um deine Suche einzuschränken.", -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["list-result--empty", _ctx.wrapperClass])
  }, _hoisted_3, 2))
}